export enum SocialNetworksEnum {
    TWITTER = 'Twitter',
    FACEBOOK = 'Facebook',
    INSTAGRAM = 'Instagram'
}